import Vue from 'vue'
import App from './App.vue'
import router from './components/router/index'
import './index.css'
import './assets/js/flexible.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')